import {Box, IconButton} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {arrowNavContainer, arrowButtonBox} from './styles';

interface ArrowMonthNavigationProps {
  onPrev: () => void;
  onNext: () => void;
  disablePrev: boolean;
  disableNext: boolean;
}

const ArrowMonthNavigation: React.FC<ArrowMonthNavigationProps> = ({
  onPrev,
  onNext,
  disablePrev,
  disableNext,
}) => (
  <Box sx={arrowNavContainer}>
    <Box sx={arrowButtonBox}>
      <IconButton onClick={onPrev} disabled={disablePrev} size="small">
        <ArrowBackIosNewIcon />
      </IconButton>
    </Box>
    <Box sx={arrowButtonBox}>
      <IconButton onClick={onNext} disabled={disableNext} size="small">
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  </Box>
);

export default ArrowMonthNavigation;
